var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmclock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12.8571C5 9.01084 8.11802 5.89282 11.9643 5.89282C15.8106 5.89282 18.9286 9.01084 18.9286 12.8571C18.9286 16.7034 15.8106 19.8214 11.9643 19.8214C8.11802 19.8214 5 16.7034 5 12.8571ZM12.7143 9.99997C12.7143 9.58576 12.3785 9.24997 11.9643 9.24997C11.5501 9.24997 11.2143 9.58576 11.2143 9.99997V12.5895C11.2143 13.0075 11.4232 13.3978 11.7709 13.6296L13.6911 14.9097C14.0358 15.1395 14.5014 15.0464 14.7312 14.7017C14.9609 14.3571 14.8678 13.8914 14.5232 13.6616L12.7143 12.4557V9.99997Z",
    fill: "#3B3B3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5356 5L18.3928 7.14286",
    stroke: "#3B3B3C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9644 5L11.9644 6.42857",
    stroke: "#3B3B3C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5356 18.5714L16.2499 20",
    stroke: "#3B3B3C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39282 18.5714L7.67854 20",
    stroke: "#3B3B3C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39282 5L5.53568 7.14286",
    stroke: "#3B3B3C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmclock);
export default __webpack_public_path__ + "static/media/Alarm clock.2c47ade99e5e852d64a8f76414adfe29.svg";
export { ForwardRef as ReactComponent };